import { connect } from 'react-redux'

import {
  selectors as UserPreferencesSelectors,
  actions as UserPreferencesActions,
} from 'data/userPreferences'

export default connect(
  state => {
    const acceptedPrivacyPolicyAt = UserPreferencesSelectors.getUserPreferences(
      state
    ).get('acceptedPrivacyPolicyAt')
    return {
      shouldDisplayPrivacyModal: acceptedPrivacyPolicyAt === null,
    }
  },
  UserPreferencesActions
)
